<template>
  <div class="home">
    <div class="top">
      <van-icon name="scan" @click="scanCode"></van-icon>
      <div class="search" @click="$store.state.showSearchLayer = true">
        <span>搜索商品</span>
        <van-icon name="search"></van-icon>
      </div>
    </div>
    <div class="scroll">
      <div class="panel-1">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(value, index) in slideDatas" :key="index">
            <van-image :src="value"></van-image>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="nav">
        <div v-for="value in navDatas" :key="value.name" @click="navToPage(value)">
          <van-image :src="value.icon"></van-image>
          <span>{{value.name}}</span>
        </div>
      </div>
      <template v-for="value in homeBlocks">
        <div class="panel-5 limited-products" :key="value.block_key" v-if="value.block_type === 'limit_discount'">
          <div class="app-title">
            <span>限时促销</span>
            <van-count-down :time="countDownTime" @finish="countDownFinish" ref="countDown">
              <template #default="timeData">
                <div class="count-down">
                  <i class="text">{{ formatTime(timeData.days * 24 + timeData.hours) }}</i>
                  <i class="colon">:</i>
                  <i class="text">{{ formatTime(timeData.minutes) }}</i>
                  <i class="colon">:</i>
                  <i class="text">{{ formatTime(timeData.seconds) }}</i>
                </div>
              </template>
            </van-count-down>
          </div>
          <div class="content" @click="goCountDownPage">
            <div v-for="item in countDownDatas" :key="item.id">
              <van-image :src="item.image"></van-image>
              <p>
                <span>￥{{item.price}}</span>
                <span v-if="item.old_price">￥{{item.old_price}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="panel-5 recommend-products" :key="value.block_key" v-else-if="value.display_type === 2 && value.goods.length">
          <div class="app-title">
            <span>{{value.title}}</span>
            <span class="gift-exclusion-tag" v-if="hasGiftExclusion(value.goods)">不参与满赠</span>
          </div>
          <div class="content">
            <div v-for="item in value.goods" :key="item.id" @click="goProductGoods(value.goods)">
              <div class="product-image-wrap">
                <van-image :src="item.image"></van-image>
                <span class="special-flag" v-if="item.is_special_price">特价</span>
                <span class="special-date" v-if="item.special_activity_date_label">
                  <b>限时</b><em>{{item.special_activity_date_label}}</em>
                </span>
              </div>
              <p class="product-price">
                <span>￥{{item.price}}</span>
                <span v-if="item.old_price">￥{{item.old_price}}</span>
              </p>
            </div>
            <div class="more-card" v-if="value.goods.length > 4" @click="goProductGoods(value.goods)">
              <van-icon name="arrow"></van-icon>
              <span>查看更多</span>
            </div>
          </div>
        </div>
        <div class="panel-2" :key="value.block_key" v-else-if="value.items.length === 3">
          <div class="app-title">
            <span>{{value.title}}</span>
          </div>
          <div class="content">
            <van-image :src="value.items[0].image" @click="goGoods(value.items[0].id)"></van-image>
            <div class="right-region">
              <van-image :src="value.items[1].image" @click="goGoods(value.items[1].id)"></van-image>
              <van-image :src="value.items[2].image" @click="goGoods(value.items[2].id)"></van-image>
            </div>
          </div>
        </div>
        <div class="panel-3" :key="value.block_key" v-else>
          <div class="app-title">
            <span>{{value.title}}</span>
            <!-- <span>更多<van-icon name="arrow"></van-icon></span> -->
          </div>
          <div class="content">
            <van-image v-for="(m, n) in value.items" :key="n" :src="m.image" @click="goGoods(m.id)"></van-image>
          </div>
        </div>
      </template>
      <div class="panel-4" v-if="hotDatas.length">
        <div class="app-title">
          <span>热销商品</span>
          <span @click="goGoodsPage">更多<van-icon name="arrow"></van-icon></span>
        </div>
        <product-list :datas="hotDatas.slice(0, 5)"></product-list>
      </div>
    </div>
    <van-overlay :show="showLayer" :lock-scroll="false" :z-index="2">
      <div class="layer" v-if="isOpenModal">
        <van-image :src="openModalImage"></van-image>
        <van-icon name="clear" @click="showLayer = false" />
      </div>
	  <div class="layer" v-if="!isOpenModal">
	    <div class="text-1" v-html="pageTips"></div>
	    <div class="btn" @click="showLayer = false">去使用</div>
	    <div class="text-2" @click="$router.push({ name: 'Coupon' })">查看我的优惠券</div>
	    <van-icon name="clear" @click="showLayer = false" />
	  </div>
    </van-overlay>
  </div>
</template>

<script>
  import CommonService from '@/io/common.js';
  import ProductList from '@/components/ProductList.vue';

  export default {
    name: 'Home',
    data() {
      return {
        showLayer: false,
        navDatas: [],
        slideDatas: [],
        recommendDatas: [],
        homeBlocks: [],
        hotDatas: [],
        countDownTime: 0,
        countDownDatas: [],
        merchantId: null,
        pageTips: null,
        openModalImage: null,
        isOpenModal: 0,
        isFirstRender: this.$store.state.allInfo
      }
    },
    components: {
      ProductList
    },
    mounted() {
      this.$toast.loading({
        message: '加载中...',
        duration: 0
      });
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          CommonService.checkRegister().then(res => {
            if (!res.is_register) {
              wx.miniProgram.redirectTo({url: `/pages/register/register?token=${this.$store.state.reqParams.token}&openid=${this.$store.state.reqParams.openid}`});
            }
          });
        }
      });
      this.initPage().then(res => {
        return Promise.all([
          this.initCountDown(res),
          this.initDatas(res),
          this.initHotDatas(res)
        ]);
      }).then(() => {
        if (this.isOpenModal && !this.isFirstRender) {
          this.showLayer = true;
        } else if (this.pageTips && !this.isFirstRender) {
          this.showLayer = true;
        }
      }).catch(err => {}).finally(() => {
        this.$toast.clear();
      });
    },
    methods: {
      navToPage(data) {
        if (data.type === 1) {
          this.$router.push({
            path: data.uri
          });
        } else {
          window.location.href = data.uri;
        }
      },
      countDownFinish() {
        this.initPage().then(res => {
          this.initCountDown(res);
        });
      },
      initPage() {
        return CommonService.allInfo().then(res => {
          this.merchantId = res.merchant.id;
          this.slideDatas = res.carousel.map(val => `${process.env.VUE_APP_IMAGE_URL}${val}`);
          this.pageTips = res.page_tips;
          this.navDatas = res.navbar;
		  this.isOpenModal = res.merchant.is_open_modal;
		  this.openModalImage = process.env.VUE_APP_IMAGE_URL+res.merchant.open_modal_image;
          return res;
        }).catch(err => {});
      },
      initCountDown(res) {
        return CommonService.countDown().then(response => {
          this.countDownTime = response.data.has_limit_discount ? response.data.discount_last_time * 1000 : 0;
          this.countDownDatas = this.formatDatas(response.data.discount_goods, res);
          this.buildHomeBlocks();
        }).catch(err => {});
      },
      goGoodsPage() {
        this.$router.push({
          path: `/goods?ids=${this.hotDatas.map(val => val.id).join(',')}`
        });
      },
      initHotDatas(res) {
        return CommonService.hotGoods().then(response => {
          this.hotDatas = this.formatDatas(response.data, res);
        });
      },
      formatDatas(sourceDatas, datas) {
        return sourceDatas.map(val => {
          let data;
          let number = 0;
          datas.cart.cart.map(m => {
            if (val.goods_id === m.goods_id) {
              number = m.num * 1;
            }
          });
          datas.goods.forEach(m => {
            if (val.goods_id === m.id) {
              data = {
                ...m,
                number,
                merchantId: this.merchantId,
                image: `${process.env.VUE_APP_IMAGE_URL}${m.image}`,
              }
            }
          });
          return data;
        });
      },
      hasGiftExclusion(goods) {
        return (goods || []).some(item => item
          && item.is_special_price
          && Number(item.exclude_gift_price) === 1);
      },
      initDatas(pageData) {
        return CommonService.indexList().then(res => {
          return Promise.all(res.data.map(val => {
            val.display_type = Number(val.display_type) === 2 ? 2 : 1;
            val.home_position = Number(val.home_position) === 1 ? 1 : 2;
            val.recomment_order = Number(val.recomment_order) || 0;
            val.block_type = 'recommend';
            val.block_key = `recommend-${val.items[0].id}`;
            val.items.map(m => {
              m.image = `${process.env.VUE_APP_IMAGE_URL}${m.recomment_cate_thumb}`;
              return m;
            });
            if (val.display_type !== 2) {
              val.goods = [];
              return Promise.resolve(val);
            }
            return Promise.all(val.items.map(item => CommonService.indexListGoods(item.id))).then(goodsResponses => {
              const goodsIds = [];
              goodsResponses.forEach(response => {
                response.data.forEach(item => {
                  if (goodsIds.indexOf(item.goods_id) === -1) {
                    goodsIds.push(item.goods_id);
                  }
                });
              });
              val.goods = this.formatDatas(goodsIds.map(goods_id => ({ goods_id })), pageData).filter(Boolean);
              return val;
            });
          }));
        }).then(recommendDatas => {
          this.recommendDatas = recommendDatas;
          this.buildHomeBlocks();
        }).catch(err => {});
      },
      buildHomeBlocks() {
        const blocks = this.recommendDatas.map(value => ({
          ...value,
          sort_key: (value.home_position === 1 ? 200000000 : 0) + value.recomment_order
        }));
        if (this.countDownTime > 0) {
          blocks.push({
            block_type: 'limit_discount',
            block_key: 'limit-discount',
            sort_key: 100000000
          });
        }
        this.homeBlocks = blocks.sort((a, b) => b.sort_key - a.sort_key);
      },
      goProductGoods(goods) {
        const ids = (Array.isArray(goods) ? goods : [goods])
          .map(item => typeof item === 'object' ? item.id : item)
          .filter(Boolean);
        this.$router.push({
          path: `/goods?ids=${ids.join(',')}`
        });
      },
      goGoods(id) {
        this.$toast.loading({
          message: '加载中...',
          duration: 0
        });
        CommonService.indexListGoods(id).then(res => {
          this.$router.push({
            path: `/goods?ids=${res.data.map(val => val.goods_id).join(',')}`
          });
        }).catch(err => {}).finally(() => {
          this.$toast.clear();
        });
      },
      goCountDownPage() {
        this.$router.push({
          path: `/goods?ids=${this.countDownDatas.map(val => val.id).join(',')}&count_down=true`
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .home {
    .top {
      display: flex;
      align-items: center;
      margin: 34 * @r 0;
      padding: 0 40 * @r;
      & > .van-icon {
        font-size: 40 * @r;
        margin-right: 46 * @r;
        color: #696969;
      }
      .search {
        height: 56 * @r;
        flex: 1;
        display: flex;
        align-items: center;
        background-color: #F3F4F7;
        border-radius: 28 * @r;
      
        /* ✅ 和搜索页一致的红色边框 */
        border: 2 * @r solid rgba(242, 76, 76, 0.4);
      
        /* ✅ 左右留白，像输入框 */
        padding: 0 28 * @r;
      
        color: #959AA3;
      
        span {
          flex: 1;
          font-size: 24 * @r;
        }
      
        .van-icon {
          font-size: 36 * @r;
          color: #959AA3;
        }
      }

    }
    .nav {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 30 * @r;
      margin-bottom: 32 * @r;
      & > div {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 10 * @r 0;
        .van-image {
          width: 100 * @r;
          margin-bottom: 10 * @r;
        }
        span {
          font-size: 24 * @r;
        }
      }
    }
    .panel-1 {
      margin-bottom: 42 * @r;
      padding: 0 30 * @r;
    }
    .panel-2,
    .panel-3,
    .panel-4,
    .panel-5 {
      padding: 0 40 * @r;
    }
    .panel-2 {
      margin-bottom: 42 * @r;
      .content {
        display: flex;
        /deep/ .van-image {
          border-radius: 8 * @r;
          img {
            border-radius: 8 * @r;
          }
        }
        & > .van-image {
          width: 50%;
          height: 336 * @r;
        }
        .right-region {
          width: 50%;
          margin-left: 14 * @r;
          .van-image {
            height: 160 * @r;
            & + .van-image {
              margin-top: 14 * @r;
            }
          }
        }
      }
    }
    .panel-3 {
      margin-bottom: 42 * @r;
      .content {
        display: flex;
        justify-content: space-between;
        /deep/ .van-image {
          flex: 1;
          box-shadow: 0 2 * @r 24 * @r 0 rgba(0, 0, 0, .1);
          height: 210 * @r;
          border-radius: 16 * @r;
          & + .van-image {
            margin-left: 16 * @r;
          }
          img {
            border-radius: 16 * @r;
          }
        }
      }
    }
    .panel-4 {
      margin-bottom: 42 * @r;
    }
    .panel-5 {
      margin-bottom: 42 * @r;
      .content {
        display: flex;
        overflow: auto;
        & > div {
          flex: 1;
          justify-content: space-between;
          // box-shadow: 0 2 * @r 24 * @r 0 rgba(0, 0, 0, .1);
          padding: 8 * @r;
          border-radius: 8 * @r;
          .van-image {
            height: 210 * @r;
            margin-bottom: 8 * @r;
          }
          p {
            font-size: 20 * @r;
            text-align: center;
            span {
              margin: 0 4 * @r;
              &:nth-of-type(1) {
                color: @color-primary;
              }
              &:nth-of-type(2) {
                opacity: .4;
                text-decoration: line-through;
              }
            }
          }
        }
      }
    }
    .recommend-products {
      .app-title {
        justify-content: flex-start;
        .gift-exclusion-tag {
          margin-left: 10 * @r;
          padding: 4 * @r 10 * @r;
          border: 1px solid rgba(245, 99, 50, .65);
          border-radius: 6 * @r;
          background: #fff3ea;
          color: @color-primary;
          font-size: 22 * @r;
          font-weight: 500;
          line-height: 1.2;
          white-space: nowrap;
        }
      }
      .content {
        & > div {
          flex: 0 0 25%;
          min-width: 25%;
          box-sizing: border-box;
          .product-image-wrap {
            width: 100%;
            height: 210 * @r;
            position: relative;
            margin-bottom: 12 * @r;
            overflow: hidden;
            border-radius: 8 * @r;
          }
          .product-image-wrap .van-image {
            width: 100%;
            height: 100%;
            margin-bottom: 0;
            /deep/ img {
              object-fit: contain;
            }
          }
          .special-flag {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            padding: 7 * @r 12 * @r 11 * @r;
            border-radius: 0 0 24 * @r 0;
            background: linear-gradient(135deg, #34d07f, #16b96a);
            color: #fff;
            font-size: 22 * @r;
            font-weight: 700;
            line-height: 1;
          }
          .special-date {
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 1;
            display: flex;
            align-items: center;
            min-height: 28 * @r;
            background: linear-gradient(90deg, rgba(255, 240, 179, .98), rgba(255, 249, 221, .94));
            color: #4b4b4b;
            font-size: 14 * @r;
            font-weight: 700;
            white-space: nowrap;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            overflow: hidden;
            b {
              flex-shrink: 0;
              align-self: stretch;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 3 * @r;
              padding: 0 5 * @r;
              background: #f35d3c;
              color: #fff;
              font-size: 14 * @r;
              font-weight: 700;
            }
            em {
              display: block;
              flex: 1;
              min-width: 0;
              padding-right: 5 * @r;
              font-size: 16 * @r;
              font-style: normal;
              line-height: 1;
              text-align: center;
            }
          }
          .product-price {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 0;
            font-size: 30 * @r;
            font-weight: 700;
            line-height: 1.25;
            span {
              display: block;
              max-width: 100%;
              white-space: nowrap;
            }
            span:nth-of-type(2) {
              margin-top: 4 * @r;
              font-size: 23 * @r;
              font-weight: 500;
            }
          }
        }
        .more-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #959AA3;
          .van-icon {
            width: auto;
            height: auto;
            margin-bottom: 14 * @r;
            font-size: 44 * @r;
          }
          span {
            font-size: 22 * @r;
          }
        }
      }
    }
    .limited-products {
      .content {
        & > div {
          flex: 0 0 25%;
          min-width: 25%;
          box-sizing: border-box;
          .van-image {
            width: 100%;
            height: 210 * @r;
            margin-bottom: 12 * @r;
            /deep/ img {
              object-fit: contain;
            }
          }
          p {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 0;
            line-height: 1.25;
            span {
              display: block;
              max-width: 100%;
              white-space: nowrap;
            }
            span:nth-of-type(1) {
              font-size: 30 * @r;
              font-weight: 700;
            }
            span:nth-of-type(2) {
              margin-top: 4 * @r;
              font-size: 23 * @r;
            }
          }
        }
      }
    }
  }
  /deep/ .van-swipe {
    height: 210 * @r;
    .van-swipe__track {
      .van-swipe-item {
        .van-image {
          height: 100%;
          border-radius: 16 * @r;
          margin: 0 10 * @r;
          img {
            border-radius: 16 * @r;
          }
        }
      }
    }
    .van-swipe__indicators {
      left: 36 * @r;
    }
  }
  .scroll {
    height: calc(100% - 124 * @r);
    overflow: auto;
  }
  .layer {
    .setImg('/dialog.png');
    width: 500 * @r;
    height: 586 * @r;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    .text-1 {
      font-size: 36 * @r;
      line-height: 50 * @r;
      text-align: center;
      margin: 100 * @r 0;
    }
    .btn {
      width: 180 * @r;
      height: 60  * @r;
      font-size: 28 * @r;
      background-color: #78b65f;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 30 * @r;
      margin: 0 auto 125 * @r auto;
    }
    .text-2 {
      font-size: 28 * @r;
      text-align: center;
      color: #FFFFFF;
    }
    .van-icon {
      position: absolute;
      top: -30 * @r;
      right: 0;
      font-size: 60 * @r;
    }
  }
</style>
